import { productsType, products } from '../../constants';
export const getPackageTrips = trips => {
  const {
    type,
    isExpressDeal,
    checkStatusUrl,
    bundleComponents
  } = trips || {};
  const firstComponent = bundleComponents[0];
  const lastComponent = bundleComponents[bundleComponents.length - 1];
  const {
    cityName,
    stateName,
    type: componentType
  } = lastComponent || {};
  let name;
  if (componentType === productsType.DRIVE) {
    name = lastComponent.title;
  } else if (componentType === productsType.STAY) {
    name = `${cityName}${stateName ? `, ${stateName}` : ''}`;
  } else if (componentType === productsType.FLY) {
    name = lastComponent.header;
  }
  const title = `Trip to ${name}`;
  const travelStartDate = firstComponent.dateHeader.split('-')[0];
  const travelEndDate = lastComponent.dateHeader.split('-')[1];
  const pkgDateHeader = `${travelStartDate}-${travelEndDate}`;
  const pkgType = bundleComponents.reduce((accComp, curComp) => {
    const {
      type
    } = curComp;
    const productName = products[type];
    accComp.push(productName);
    return accComp;
  }, []).join(' + ');
  return {
    type,
    isExpressDeal,
    checkStatusUrl,
    title,
    dateHeader: pkgDateHeader,
    pkgType
  };
};